import TimeBlock from './TimeBlock';

export default TimeBlock;



// WEBPACK FOOTER //
// ./src/TimeBlock/index.js